export default "__VITE_ASSET__BvH5BtZd__"